import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import { CHAT_MESSAGE_ALL, CHAT_MESSAGE_LIST, CHAT_MESSAGE_POST, GLOBAL_STATE } from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const CHAT = GLOBAL_STATE

const chatSlice = createSlice({
  name: CHAT,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(actionCreators.chatMessageAllClear, state => {
      state[CHAT_MESSAGE_ALL] = defaultState()
    })

    builder.addCase(actionCreators.chatMessageListClear, state => {
      state[CHAT_MESSAGE_LIST] = defaultState()
    })

    builder
      .addCase(actionCreators.chatMessageAll.pending, state => {
        state[CHAT_MESSAGE_ALL].loading = true
      })
      .addCase(actionCreators.chatMessageAll.rejected, (state, action) => {
        state[CHAT_MESSAGE_ALL].loading = false
        state[CHAT_MESSAGE_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.chatMessageAll.fulfilled, (state, action) => {
        state[CHAT_MESSAGE_ALL].loading = false
        state[CHAT_MESSAGE_ALL].error = null
        state[CHAT_MESSAGE_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.chatMessageList.pending, state => {
        state[CHAT_MESSAGE_LIST].loading = true
      })
      .addCase(actionCreators.chatMessageList.rejected, (state, action) => {
        state[CHAT_MESSAGE_LIST].loading = false
        state[CHAT_MESSAGE_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.chatMessageList.fulfilled, (state, action) => {
        state[CHAT_MESSAGE_LIST].loading = false
        state[CHAT_MESSAGE_LIST].error = null
        state[CHAT_MESSAGE_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.chatMessagePost.pending, state => {
        state[CHAT_MESSAGE_POST].loading = true
      })
      .addCase(actionCreators.chatMessagePost.rejected, (state, action) => {
        state[CHAT_MESSAGE_POST].loading = false
        state[CHAT_MESSAGE_POST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.chatMessagePost.fulfilled, (state, action) => {
        state[CHAT_MESSAGE_POST].loading = false
        state[CHAT_MESSAGE_POST].error = null
        state[CHAT_MESSAGE_POST].data = action.payload
      })
  },
})

export const { reducer: chatReduser } = chatSlice
